/**
 * Orden FIJO de la entrada (spec §4, GEN-PX-007). Un hueco por sección.
 *
 * Añadir una sección = poner aquí su `Componente` (y, si puede no tener datos,
 * su `tieneDatos(ctx)`). Sin `Componente`, la sección no existe todavía y no se
 * pinta: ni título, ni hueco, ni «Próx.» (principio 6: lo que no existe no se ve).
 * Cuando una épica la rellene, no se toca ni el orden ni Entrada.jsx.
 *
 * `ctx` lo arma Home: { user, agents, disponibles, enrutadora, palette, theme,
 * onSelectAgent, onSelectChat, onVerEquipo, onVerPersonas, onInvitar, onVerPerfil }. Los componentes devuelven su propio <section>.
 */

import Cabecera from './Cabecera.jsx'
import EquipoIA, { equipoTieneDatos } from './EquipoIA.jsx'
import Empleados from './Empleados.jsx'

export const SECCIONES = [
  { id: 'cabecera', Componente: Cabecera },
  { id: 'atencion', Componente: null },   // Requiere tu atención — épica pendiente
  { id: 'asuntos',  Componente: null },   // Tus asuntos — épica pendiente
  { id: 'equipo',   Componente: EquipoIA, tieneDatos: equipoTieneDatos },
  { id: 'dos-columnas', columnas: [       // Mientras no estabas + Tu estrategia
    { id: 'mientras',   Componente: null },
    { id: 'estrategia', Componente: null },
  ] },
  { id: 'empleados', Componente: Empleados },  // Tus empleados (GEN-PX-012): se pinta sola si hay datos
]
